<div class="main-body app sidebar-mini Light-mode s"  [ngClass]="mainSidebarOpen">
    <!-- Page -->
    <div class="page">

        <!-- main-sidebar -->
        <app-sidebar
        (sendMouseEvent) = "hoverEffect($event,2)"
         ></app-sidebar>
         <!-- (mouseover)="hoverEffect($event,1)" (mouseout)="hoverEffect($event,2)" -->
        <!-- <app-sidemenu></app-sidemenu> -->
        <!-- main-sidebar -->

        <!-- main-content -->
        <div class="main-content app-content">

            <!-- main-header -->
            <app-header></app-header>
            <!-- <div class="jumps-prevent"></div> -->
            <!-- /main-header -->
            
            <!-- container (click)="clickonBody()"-->
            <div class="container-fluid" style="padding: 10px;" >
                <app-loader></app-loader>
                <router-outlet>
                </router-outlet>
            </div>
            <!-- /Container -->
        </div>
        <!-- /main-content --> 

        <!-- Sidebar-right-->
        <!-- <app-notification-sidebar></app-notification-sidebar> -->
        <!--/Sidebar-right-->  

        <!-- Footer opened -->
        <app-footer></app-footer>
        <!-- Footer closed -->
        <app-tap-to-top></app-tap-to-top>
    </div>
    <!-- End Page -->
</div>
